export default "__VITE_ASSET__WUE249CH__"